import { render, staticRenderFns } from "./UpdateInfo.vue?vue&type=template&id=09f84508&scoped=true"
import script from "./UpdateInfo.vue?vue&type=script&lang=js"
export * from "./UpdateInfo.vue?vue&type=script&lang=js"
import style0 from "./UpdateInfo.vue?vue&type=style&index=0&id=09f84508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f84508",
  null
  
)

export default component.exports